// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__-5g9w","header":"MergedInvoice_header__155a9"};